import angular from 'angular'
import moment from 'moment-timezone'

angular.module('admin.rewards.edit', []).controller('RewardsEditCtrl', RewardsEditCtrl)

/** @ngInject */
function RewardsEditCtrl(
  $scope,
  $rootScope,
  $state,
  $q,
  $timeout,
  $stateParams,
  RewardsService,
  UploadService,
  UserSegmentationService,
  TranslatorService,
  EventService,
  NotificationsService,
  CouponsService,
) {
  var vm = this

  vm.model = {}
  vm.pathImgH = ''
  vm.id = $stateParams.id
  vm.isOpen = false
  vm.rewardTranslations = []
  vm.title = null
  vm.channels = []
  vm.waitChannel = true
  vm.waitSet = true
  vm.coupons = []

  vm.types = [
    {
      id: 0,
      value: 'Coming Soon',
    },
    {
      id: 1,
      value: 'Coins',
    },
    {
      id: 2,
      value: 'Bundle Discount',
    },
    {
      id: 3,
      value: 'Odds Boost',
    },
    {
      id: 4,
      value: 'Award Bundle',
    },
    {
      id: 5,
      value: 'Cash',
    },
    {
      id: 6,
      value: 'Coupon',
    },
    {
      id: 7,
      value: 'IRL (Swag / Physical)',
    },
  ]

  vm.category = [
    {
      id: 1,
      value: 'Collector Level',
    },
    {
      id: 2,
      value: 'Checklist Award',
    },
  ]

  vm.levels = [
    {
      id: 0,
      value: 'New',
    },
    {
      id: 1,
      value: 'Bronze',
    },
    {
      id: 2,
      value: 'Silver',
    },
    {
      id: 3,
      value: 'Gold',
    },
    {
      id: 4,
      value: 'Platinum',
    },
    {
      id: 5,
      value: 'Diamond',
    },
    {
      id: 6,
      value: 'Master',
    },
    {
      id: 7,
      value: 'Grandmaster',
    },
  ]

  vm.model.k = vm.types[0].id
  vm.model.l = vm.levels[0].id
  vm.model.tr = 1
  vm.tiers = [
    {
      id: 1,
      value: '1',
    },
    {
      id: 2,
      value: '2',
    },
    {
      id: 3,
      value: '3',
    },
    {
      id: 4,
      value: '4',
    },
    {
      id: 5,
      value: '5',
    },
  ]

  var isDate = function (date) {
    return new Date(date) !== 'Invalid Date' && !isNaN(new Date(date))
  }

  vm.openCalendar = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpen = true
  }

  var whichPage = window.location.pathname
  vm.isCheckListPage = whichPage.indexOf('checklist') !== -1

  vm.loadedModal = false
  if (vm.isCheckListPage) {
    if (!vm.loadedModal && localStorage.getItem('checklist_reward_id') !== null) {
      vm.id = parseInt(localStorage.getItem('checklist_reward_id'))
      vm.model = {
        k: vm.types[4].id,
        cat: vm.category[1].id,
      }
      vm.pathImgH = ''
      vm.title = null
      vm.channel = null
      vm.set = null
      vm.bundle = null
      vm.waitChannel = true
      vm.waitSet = true

      if (vm.id === 0) {
        vm.rewardTranslations = []
      }
      load()
      loadTranslations()
    }
  }

  $('#modalReward').on('hidden.bs.modal', function () {
    vm.loadedModal = false
  })

  $rootScope.$on('modalReward', function (event, id) {
    vm.model = {
      k: vm.types[4].id,
      cat: vm.category[1].id,
    }
    vm.pathImgH = ''
    vm.title = null
    vm.channel = null
    vm.set = null
    vm.bundle = null
    vm.waitChannel = true
    vm.waitSet = true
    vm.id = parseInt(localStorage.getItem('checklist_reward_id')) || id

    if (vm.id === 0) {
      vm.rewardTranslations = []
    }
    load()
    loadTranslations()
  })

  function load() {
    if (vm.id !== '0') {
      EventService.listChannels().then(function (resultChannels) {
        vm.channels = resultChannels.results
        RewardsService.get(vm.id).then(function (result) {
          if (result.results.img === undefined) {
            result.results.img = ''
          }
          vm.model = result.results
          if (vm.model['ts-p'] !== undefined && vm.model['ts-p'] !== 0) {
            vm.model['ts-p'] = vm.model['ts-p']
              .toString()
              .substring(0, vm.model['ts-p'].toString().length - 3)
            vm.model['ts-p'] = new Date(parseInt(vm.model['ts-p']))
            vm.data1 = angular.copy(vm.model['ts-p'])
          }

          vm.title = vm.model.t
          if (vm.model['id-cpn']) {
            CouponsService.getByIds(vm.model['id-cpn']).then(function (results) {
              $('#couponSelect').select2('data', results.results[0])
            })
          }
          if (vm.model['id-b']) {
            UserSegmentationService.getBundle(vm.model['id-b']).then(function (resultBundle) {
              var bundle = resultBundle.results
              UserSegmentationService.getSet(bundle['id-s']).then(function (result) {
                var set = result.results
                var channel = _.find(vm.channels, { id: set['id-ch'] })
                vm.channel = channel.id
                // $timeout(function(){
                vm.setTemp = set.id
                vm.bundleTemp = vm.model['id-b']
                //   // $timeout(function(){
                //   //   vm.bundle = vm.model["id-b"];
                //   // }, 700)
                // }, 250)
              })
            })
          }
        })
      })
    } else {
      EventService.listChannels().then(function (result) {
        vm.channels = result.results
      })
      vm.model.img = ''
    }
  }

  load()

  // var makeTranslation = function (t, txt, currentTranslations, paramsId, route) {
  //   TranslatorService.translateProductAllLanguage(t, txt).then(function (res) {
  //     var languages = ['ja', 'ko', 'zh', 'zh-TW']

  //     for (var i = 0; i < currentTranslations.length; i++) {
  //       for (var key in res.t.results) {
  //         if (currentTranslations[i].comm === 'JP' && key.indexOf('ja') !== -1) {
  //           languages.remove('ja')
  //         }
  //         if (currentTranslations[i].comm === 'KR' && key.indexOf('ko') !== -1) {
  //           languages.remove('ko')
  //         }
  //         if (currentTranslations[i].comm === 'SC' && key.indexOf('zh') !== -1) {
  //           languages.remove('zh')
  //         }
  //         if (currentTranslations[i].comm === 'TC' && key.indexOf('zh-TW') !== -1) {
  //           languages.remove('zh-TW')
  //         }
  //       }
  //     }

  //     // if (vm.title && vm.title === t && languages.length === 0 && currentTranslations.length === 4) {
  //     //   $state.go(route);
  //     //   return
  //     // }

  //     if (vm.model.id !== undefined && vm.model.id !== '' && vm.model.id !== 0) {
  //       var promises = []

  //       for (var i = 0; i < currentTranslations.length; i++) {
  //         if (currentTranslations[i].comm === 'SC' && res.t.results) {
  //           var exist = _.find(languages, 'zh')
  //           if (exist) {
  //             promises.push(
  //               RewardsService.saveTranslation(paramsId, {
  //                 'id-u': 0,
  //                 comm: 'SC',
  //                 t: res.t.results.zh,
  //                 txt: res.txt.results.zh,
  //               }),
  //             )
  //           } else {
  //             promises.push(
  //               RewardsService.updateTranslation(currentTranslations[i].id, {
  //                 'id-u': 0,
  //                 t: res.t.results.zh,
  //                 txt: res.txt.results.zh,
  //               }),
  //             )
  //           }
  //           continue
  //         }
  //         if (currentTranslations[i].comm === 'TC' && res.t.results) {
  //           var exist = _.find(languages, 'zh-TW')
  //           if (exist) {
  //             promises.push(
  //               RewardsService.saveTranslation(paramsId, {
  //                 'id-u': 0,
  //                 comm: 'TC',
  //                 t: res.t.results['zh-TW'],
  //                 txt: res.txt.results['zh-TW'],
  //               }),
  //             )
  //           } else {
  //             promises.push(
  //               RewardsService.updateTranslation(currentTranslations[i].id, {
  //                 'id-u': 0,
  //                 t: res.t.results['zh-TW'],
  //                 txt: res.txt.results['zh-TW'],
  //               }),
  //             )
  //           }
  //           continue
  //         }
  //         if (currentTranslations[i].comm === 'KR' && res.t.results) {
  //           var exist = _.find(languages, 'ko')
  //           if (exist) {
  //             promises.push(
  //               RewardsService.saveTranslation(paramsId, {
  //                 'id-u': 0,
  //                 comm: 'KR',
  //                 t: res.t.results.ko,
  //                 txt: res.txt.results.ko,
  //               }),
  //             )
  //           } else {
  //             promises.push(
  //               RewardsService.updateTranslation(currentTranslations[i].id, {
  //                 'id-u': 0,
  //                 t: res.t.results.ko,
  //                 txt: res.txt.results.ko,
  //               }),
  //             )
  //           }
  //           continue
  //         }
  //         if (currentTranslations[i].comm === 'JP' && res.t.results) {
  //           var exist = _.find(languages, 'ja')
  //           if (exist) {
  //             promises.push(
  //               RewardsService.saveTranslation(paramsId, {
  //                 'id-u': 0,
  //                 comm: 'JP',
  //                 t: res.t.results.ja,
  //                 txt: res.txt.results.ja,
  //               }),
  //             )
  //           } else {
  //             promises.push(
  //               RewardsService.updateTranslation(currentTranslations[i].id, {
  //                 'id-u': 0,
  //                 t: res.t.results.ja,
  //                 txt: res.txt.results.ja,
  //               }),
  //             )
  //           }
  //           continue
  //         }
  //       }

  //       $q.all(promises)
  //         .then(function () {
  //           if (vm.isCheckListPage) {
  //             $('#modalReward').modal('hide')
  //           } else {
  //             $state.go(route)
  //           }
  //         })
  //         .catch(function (err) {
  //           swal('Error in translation, please send message to qp2 administrator!', '', 'error')
  //         })
  //     }

  //     var promises = []

  //     for (var i = 0; i < languages.length; i++) {
  //       if (languages[i] === 'zh' && res.t.results) {
  //         promises.push(
  //           RewardsService.saveTranslation(paramsId, {
  //             'id-u': 0,
  //             comm: 'SC',
  //             t: res.t.results.zh,
  //             txt: res.txt.results.zh,
  //           }),
  //         )
  //       }
  //       if (languages[i] === 'zh-TW' && res.t.results) {
  //         promises.push(
  //           RewardsService.saveTranslation(paramsId, {
  //             'id-u': 0,
  //             comm: 'TC',
  //             t: res.t.results['zh-TW'],
  //             txt: res.txt.results['zh-TW'],
  //           }),
  //         )
  //       }
  //       if (languages[i] === 'ko' && res.t.results) {
  //         promises.push(
  //           RewardsService.saveTranslation(paramsId, {
  //             'id-u': 0,
  //             comm: 'KR',
  //             t: res.t.results.ko,
  //             txt: res.txt.results.ko,
  //           }),
  //         )
  //       }
  //       if (languages[i] === 'ja' && res.t.results) {
  //         promises.push(
  //           RewardsService.saveTranslation(paramsId, {
  //             'id-u': 0,
  //             comm: 'JP',
  //             t: res.t.results.ja,
  //             txt: res.txt.results.ja,
  //           }),
  //         )
  //       }
  //     }

  //     $q.all(promises)
  //       .then(function () {
  //         if (vm.isCheckListPage) {
  //           $('#modalReward').modal('hide')
  //         } else {
  //           $state.go(route)
  //         }
  //       })
  //       .catch(function () {
  //         swal('Error in translation, please send message to qp2 administrator!', '', 'error')
  //       })
  //   })
  // }

  vm.save = function () {
    var model = angular.copy(vm.model)
    var isUpdate = model.id !== undefined && model.id !== '' && model.id !== 0
    delete model.ts
    delete model['ts-p']

    if (!model.t) {
      swal('Title field is required.', '', 'error')
      return
    }

    if (model.t.length > 100) {
      swal('Title should be 100 characters or fewer', '', 'error')
      return
    }

    if (model['txt'] && model['txt'].length > 100) {
      swal('Description should be 100 characters or fewer', '', 'error')
      return
    }

    // if (model.f) {
    //   if (model.f < 1) {
    //     swal("The factor should be greater than 1", "", "error");
    //     return;
    //   }
    // }

    if (model.k === 1) {
      model.f = 0
      model['c-u'] = 0
    } else if (model.k === 2 || model.k === 3) {
      model.c = 0
      if (model['c-u'] === undefined || model['c-u'] === null) {
        swal('The uses is required', '', 'error')
        return
      }
    }

    if (model.cat === 2) {
      model['c-u'] = 0
      model.c = 0
      model.f = 0
      delete model.l
      delete model.tr
    }

    if (vm.data1 !== undefined && vm.data1 !== '' && vm.data1 !== null) {
      if (isDate(vm.data1)) {
        var date = parseInt(new Date(new Date(vm.data1).setSeconds(0)).getTime() * 1000)
        model['ts-p'] = date
      } else {
        swal('Date field invalid.', '', 'error')
        return
      }
    } else {
      model['ts-p'] = null
    }

    if (vm.bundle) {
      model['id-b'] = vm.bundle
    }

    var couponId = $('#couponSelect').select2('val')
    if (couponId) {
      model['id-cpn'] = parseInt(couponId)
    }

    if (isUpdate) {
      RewardsService.update(model.id, model).then(
        function (result) {
          localStorage.setItem('checklist_reward_id', result.results.id)
          // makeTranslation(model.t, model.txt, vm.rewardTranslations, model.id, 'admin.rewards')
          $state.go('admin.rewards')
        },
        function (err) {
          $timeout(function () {
            swal(err.error.message, '', 'error')
          }, 200)
        },
      )
    } else {
      model.n = 1
      RewardsService.save(model).then(
        function (result) {
          localStorage.setItem('checklist_reward_id', result.results.id)
          // makeTranslation(
          //   model.t,
          //   model.txt,
          //   vm.rewardTranslations,
          //   result.results.id,
          //   'admin.rewards',
          // )
          $state.go('admin.rewards')
        },
        function (err) {
          $timeout(function () {
            swal(err.error.message, '', 'error')
          }, 200)
        },
      )
    }
  }

  vm.cancel = function () {
    $state.go('admin.rewards')
  }

  vm.uploadH = function (item) {
    if (vm.pathImgH.type === 'image/tiff') {
      swal('Unsupported extension', '', 'warning')
      return
    }

    vm.loadH = true
    UploadService.save('rewards', vm.pathImgH, 'img', item.id).then(function (fileName) {
      vm.loadH = false
      item.img = fileName
    })
  }

  vm.translate = {}
  vm.pathImgTranslation = ''
  vm.loadTranslation = false
  vm.addTranslate = function () {
    vm.translate = {}
    $('#modalTranslate').modal('show')
  }

  function loadTranslations() {
    RewardsService.listTranslations(vm.id).then(function (result) {
      vm.rewardTranslations = result.results
    })
  }

  loadTranslations()

  vm.classDisabled = function () {
    if (!vm.translate.comm || !vm.translate.t || !vm.translate.txt) {
      return 'is-disabled'
    } else {
      return
    }
  }

  vm.saveTranslate = function () {
    if (vm.translate.id) {
      RewardsService.updateTranslation(vm.translate.id, vm.translate).then(
        function () {
          loadTranslations()
          vm.translate = {}
          $('#modalTranslate').modal('hide')
        },
        function (err) {
          swal(err.error.message, '', 'error')
        },
      )
    } else {
      RewardsService.saveTranslation(vm.id, vm.translate).then(
        function () {
          loadTranslations()
          vm.translate = {}
          $('#modalTranslate').modal('hide')
        },
        function (err) {
          swal(err.error.message, '', 'error')
        },
      )
    }
  }

  vm.editTranslate = function (id) {
    RewardsService.getTranslation(id).then(
      function (result) {
        vm.translate = result.results
        $('#modalTranslate').modal('show')
      },
      function (err) {
        swal(err.error.message, '', 'error')
      },
    )
  }

  vm.deleteTranslate = function (id) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          RewardsService.removeTranslation(id).then(
            function () {
              loadTranslations()
              vm.translate = {}
              $('#modalTranslate').modal('hide')
            },
            function (err) {
              $timeout(function () {
                swal(err.error.message, '', 'error')
              }, 500)
            },
          )
        } else {
          return
        }
      },
    )
  }

  vm.uploadTranslation = function (item) {
    vm.loadTranslation = true
    UploadService.save('rewards', vm.pathImgTranslation, 'img', item.id).then(function (fileName) {
      vm.loadTranslation = false
      item.img = fileName
    })
  }

  var watch = $scope.$watch('vm.channel', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    NotificationsService.listAdminSets(newVal).then(function (response) {
      vm.sets = response.results
      if (vm.setTemp) {
        vm.set = vm.setTemp
        vm.setTemp = null
      }
      vm.bundles = []
      vm.waitSet = true
      vm.waitChannel = false
    })
  })

  var watch1 = $scope.$watch('vm.set', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    RewardsService.listBundlesAward(newVal).then(function (response) {
      vm.bundles = []
      var bundles = response.results
      for (var i = 0; i < bundles.length; i++) {
        var b = bundles[i]
        b.t = b.id + ' - ' + b.t
        vm.bundles.push(b)
      }
      if (vm.bundleTemp) {
        vm.bundle = vm.bundleTemp
        vm.bundleTemp = null
      }
      vm.waitSet = false
    })
  })

  var watch2 = $scope.$watch('vm.data1', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    if (newVal) {
      vm.timezoneDate1NY = moment(newVal).tz('America/New_York').format('MM/DD/YYYY HH:mm A')
      vm.timezoneDate1LA = moment(newVal).tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm A')
    }
  })

  $scope.$on('$destroy', function () {
    watch()
    watch1()
    watch2()
  })

  vm.closeModalChecklist = function () {
    $('#modalReward').modal('hide')
  }

  vm.changeType = function () {
    if (vm.model.k === 6) {
    }
  }

  vm.openModalCoupon = function () {
    $timeout(function () {
      $('#modalCoupon').modal('show')
    }, 250)
  }

  vm.modelCoupon = {}
  vm.isOpen1 = false
  vm.isOpen2 = false
  vm.dur = null

  vm.creditTypes = [
    {
      id: 1,
      name: 'Primary Market',
    },
    {
      id: 2,
      name: 'Aftermarket',
    },
  ]

  vm.openCalendar1 = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpen1 = true
  }

  vm.openCalendar2 = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpen2 = true
  }

  var isDate = function (date) {
    return new Date(date) !== 'Invalid Date' && !isNaN(new Date(date))
  }

  vm.applyDur = function () {
    switch (vm.durValue) {
      case 'hour':
        // convert duration to hour
        vm.modelCoupon.dur = vm.dur * 60 * 60 * 1000000000
        break
      case 'day':
        // convert duration to day
        vm.modelCoupon.dur = vm.dur * 60 * 60 * 24 * 1000000000
        break
      case 'week':
        // convert duration to week
        vm.modelCoupon.dur = vm.dur * 60 * 60 * 24 * 7 * 1000000000
        break
    }
  }

  vm.saveCoupon = function () {
    var model = angular.copy(vm.modelCoupon)

    if (vm.data1) {
      if (isDate(vm.data1)) {
        var date = parseInt(new Date(new Date(vm.data1).setSeconds(0)).getTime() * 1000)
        model['ts-x'] = date
      } else {
        swal('Date field invalid.', '', 'error')
        return
      }
    } else {
      model['ts-x'] = null
    }

    if (vm.data2) {
      if (isDate(vm.data2)) {
        var date = parseInt(new Date(new Date(vm.data2).setSeconds(0)).getTime() * 1000)
        model['ts-start'] = date
      } else {
        swal('Date field invalid.', '', 'error')
        return
      }
    } else {
      model['ts-start'] = null
    }

    if (model.id) {
      CouponsService.update(model.id, model).then(function (res) {
        vm.model['id-cpn'] = res.results.id
        $timeout(function () {
          $('#modalCoupon').modal('hide')
        }, 250)
      })
    } else {
      CouponsService.save(model).then(function (res) {
        vm.coupons = result.results
        vm.model['id-cpn'] = res.results.id
        $timeout(function () {
          $('#modalCoupon').modal('hide')
        }, 250)
      })
    }
  }

  vm.cancelCoupon = function () {
    $('#modalCoupon').modal('hide')
    $timeout(function () {
      $('body').addClass('modal-open')
    }, 500)
  }

  $('#modalCoupon').on('hidden.bs.modal', function () {
    $('body').addClass('modal-open')
  })

  vm.loadImg = false
  vm.uploadImg = function (item) {
    vm.loadImg = true
    var id = 0
    if (item.id) {
      id = item.id
    }
    UploadService.save('coupons', vm.pathImg, 'img', id).then(function (fileName) {
      vm.loadImg = false
      item.img = fileName
    })
  }

  var watch11 = $scope.$watch('vm.data1', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    if (newVal) {
      vm.timezoneDate1NY = moment(newVal).tz('America/New_York').format('MM/DD/YYYY HH:mm A')
      vm.timezoneDate1LA = moment(newVal).tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm A')
    }
  })

  var watch12 = $scope.$watch('vm.data2', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    if (newVal) {
      vm.timezoneDate2NY = moment(newVal).tz('America/New_York').format('MM/DD/YYYY HH:mm A')
      vm.timezoneDate2LA = moment(newVal).tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm A')
    }
  })

  $scope.$on('$destroy', function () {
    watch11()
    watch12()
  })
}
